import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { SiZalo } from "react-icons/si";
import { SERVICES, OFFICES, CONTACT } from "@/data/services";

export const Footer = () => {
  return (
    <footer className="bg-brand-navy text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="text-2xl font-bold text-white">ImmiLaw<span className="text-brand-gold">.VN</span></span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Professional Vietnam immigration &amp; legal consultancy. Visa, business registration, extensions and overstay resolution — handled with care and full regulatory compliance.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold font-bold mb-4">Services</h4>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.key}>
                <Link to={`/services/${s.slug}`} className="text-sm text-slate-400 hover:text-white transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold font-bold mb-4">Offices</h4>
          <ul className="space-y-4">
            {OFFICES.map((o) => (
              <li key={o.city} className="flex gap-2.5 text-sm">
                <MapPin className="w-4 h-4 text-brand-red shrink-0 mt-0.5" />
                <span><span className="text-white font-semibold block">{o.city}</span><span className="text-slate-400">{o.address}</span></span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2.5 text-slate-400 hover:text-white transition-colors"><Phone className="w-4 h-4 text-brand-red" /> {CONTACT.phoneDisplay}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 text-slate-400 hover:text-white transition-colors"><Mail className="w-4 h-4 text-brand-red" /> {CONTACT.email}</a></li>
            <li className="flex items-center gap-2.5 text-slate-400"><SiZalo className="w-4 h-4 text-[#0068FF]" /> Chat with us on Zalo</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} ImmiLaw.VN — Immigration &amp; Legal Services. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy &amp; Policy</Link>
            <span className="text-slate-600">·</span>
            <span className="text-center sm:text-right">This is not an official Vietnam government website.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
